// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__36dZu","name":"Header_name__3tcSO","birthday":"Header_birthday__3kzAy","skeleton":"Header_skeleton__1ESgk"};